import { admitBasemapEditor } from "./basemaps";
import { admitEditor, writeDraftPage } from "./drafts";
import {
  admitPlayer,
  getAgentState,
  getAgentVersionPin,
  getCatalogBlob,
  getGame,
  judgeLiveInput,
  recordAgentFailure,
  setAgentState,
  setCasting,
  setCheckpoint,
  setGameMaster,
  setLastOnline,
  setLive,
  setLobby,
} from "./endpoints";

export { BasemapEditorAdmission } from "./basemaps";
export { EditorAdmission } from "./drafts";
export { internalPaths, internalRoutes } from "./paths";
export {
  AgentVersionPin,
  Casting,
  CatalogObjectPin,
  GatewayRequestHeaders,
  JudgeLiveInputRequest,
  JudgeLiveInputResponse,
  LIVE_INPUT_MAX_LENGTH,
  LiveBan,
  LiveInputKind,
  LobbyCopy,
  PlayerAdmission,
  PROVIDER_CONTACTED_HEADER,
  PROVIDER_NOT_CONTACTED,
  RecordCastingResponse,
  RecordCheckpointRequest,
  RecordCheckpointResponse,
  RecordLastOnlineResponse,
  RecordLiveResponse,
  RecordLobbyResponse,
  SessionGame,
  TelemetrySignal,
} from "./schemas";

/** The catalog, game, draft, and live moderation routes only other Pax services may call. */
export const contract = {
  catalog: {
    blobs: { get: getCatalogBlob },
    agentVersions: { get: getAgentVersionPin },
  },
  games: {
    get: getGame,
    agentState: { get: getAgentState, set: setAgentState },
    checkpoint: { set: setCheckpoint },
    gameMaster: { set: setGameMaster },
    members: { casting: { set: setCasting }, lastOnline: { set: setLastOnline } },
    lobby: { set: setLobby },
    live: { set: setLive },
    admission: admitPlayer,
    agentFailures: { create: recordAgentFailure },
  },
  drafts: {
    admission: admitEditor,
    page: { set: writeDraftPage },
  },
  basemaps: { admission: admitBasemapEditor },
  moderation: { liveInputs: { create: judgeLiveInput } },
} as const;
